import { default as energy_45green_45practicesyOJDq3UaIiMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue?macro=true";
import { default as fun_45part_45journeyEbRoh6cNkYMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue?macro=true";
import { default as homesafe_45colorado_45master_45builderFqKoB9qX1vMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue?macro=true";
import { default as how_45to_45build_45with_45usU0AMb5eOpbMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/how-to-build-with-us.vue?macro=true";
import { default as indexBleDxhtVBSMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/index.vue?macro=true";
import { default as our_45team9NeELQURFTMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue?macro=true";
import { default as preferred_45lender8Xif8u2qUUMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue?macro=true";
import { default as realtor_45resourcesysr2Ntet62Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue?macro=true";
import { default as _91post_93lBoVDjBplaMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/blog/[post].vue?macro=true";
import { default as indexrPrcp8A4vWMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue?macro=true";
import { default as indexP25F3Fe0r3Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/blog/index.vue?macro=true";
import { default as _91_46_46_46slug_93ddwMqJmEPpMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue?macro=true";
import { default as indexHt7RZpWnYZMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue?macro=true";
import { default as central_45park_45special_45offer28wB4AiENWMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue?macro=true";
import { default as ask_45a_45question7Xn4FiGFYuMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue?macro=true";
import { default as career_45opportunitiesEkK5P5SRYgMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue?macro=true";
import { default as faqGpfUPhBydPMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue?macro=true";
import { default as homeowner_45resourcesUEY7bB1HXnMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue?macro=true";
import { default as indexeIDe1a4SPQMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue?macro=true";
import { default as our_45locationsiUMWDW55u3Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue?macro=true";
import { default as current_45offersxy1mGaWzwGMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/current-offers.vue?macro=true";
import { default as indexHRy12ngdA1Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue?macro=true";
import { default as indexD2PJucc5zgMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/events/index.vue?macro=true";
import { default as index0V08VrZyl7Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue?macro=true";
import { default as indexMmvppV54c5Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue?macro=true";
import { default as index7cEVnkZD7RMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue?macro=true";
import { default as indexfU9n3gZe3dMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue?macro=true";
import { default as index1Eborj6IasMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/index.vue?macro=true";
import { default as knolls_45hoa_45informationgXnrT0qNOXMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue?macro=true";
import { default as land_45acquisitionDaIGod2u5xMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue?macro=true";
import { default as brents_45place5SxJlqPSN4Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue?macro=true";
import { default as experience_45lower_45maintenance5RB1H5rIC2Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue?macro=true";
import { default as _91testimonial_93WB7FoknLD1Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue?macro=true";
import { default as index0DBcSS2QWDMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue?macro=true";
import { default as indextSUPFlsqFaMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue?macro=true";
import { default as whats_45lifefullness9QWQdrLpSUMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue?macro=true";
import { default as _91_46_46_46slug_93aM6p4LBRFXMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue?macro=true";
import { default as my_45favoritessJ0pxTkF0hMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/my-favorites.vue?macro=true";
import { default as new_45home_45search6Et2b7W5l0Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/new-home-search.vue?macro=true";
import { default as easyhouseI3M84Vp3ujMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue?macro=true";
import { default as limitededitionUnYayO26Z7Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue?macro=true";
import { default as wee_45cottagexmnncYuK6OMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue?macro=true";
import { default as indexc7XJjNFFRKMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue?macro=true";
import { default as our_45neighborhoodsW3ixkecGjGMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue?macro=true";
import { default as partner_45with_45usNBxHTIxAfpMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue?macro=true";
import { default as peacockK6Ffff2U7WMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/peacock.vue?macro=true";
import { default as privacytermsBHlYfLgB1HMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/privacyterms.vue?macro=true";
import { default as sandboxBtaV080HPWMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/sandbox.vue?macro=true";
import { default as _91_46_46_46slug_93yVJLj5lxG2Meta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue?macro=true";
import { default as component_45stubekCUiKQWjcMeta } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubekCUiKQWjc } from "/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: energy_45green_45practicesyOJDq3UaIiMeta?.name ?? "about-us-energy-green-practices",
    path: energy_45green_45practicesyOJDq3UaIiMeta?.path ?? "/about-us/energy-green-practices",
    meta: energy_45green_45practicesyOJDq3UaIiMeta || {},
    alias: energy_45green_45practicesyOJDq3UaIiMeta?.alias || [],
    redirect: energy_45green_45practicesyOJDq3UaIiMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/energy-green-practices.vue").then(m => m.default || m)
  },
  {
    name: fun_45part_45journeyEbRoh6cNkYMeta?.name ?? "about-us-fun-part-journey",
    path: fun_45part_45journeyEbRoh6cNkYMeta?.path ?? "/about-us/fun-part-journey",
    meta: fun_45part_45journeyEbRoh6cNkYMeta || {},
    alias: fun_45part_45journeyEbRoh6cNkYMeta?.alias || [],
    redirect: fun_45part_45journeyEbRoh6cNkYMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/fun-part-journey.vue").then(m => m.default || m)
  },
  {
    name: homesafe_45colorado_45master_45builderFqKoB9qX1vMeta?.name ?? "about-us-homesafe-colorado-master-builder",
    path: homesafe_45colorado_45master_45builderFqKoB9qX1vMeta?.path ?? "/about-us/homesafe-colorado-master-builder",
    meta: homesafe_45colorado_45master_45builderFqKoB9qX1vMeta || {},
    alias: homesafe_45colorado_45master_45builderFqKoB9qX1vMeta?.alias || [],
    redirect: homesafe_45colorado_45master_45builderFqKoB9qX1vMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/homesafe-colorado-master-builder.vue").then(m => m.default || m)
  },
  {
    name: how_45to_45build_45with_45usU0AMb5eOpbMeta?.name ?? "about-us-how-to-build-with-us",
    path: how_45to_45build_45with_45usU0AMb5eOpbMeta?.path ?? "/about-us/how-to-build-with-us",
    meta: how_45to_45build_45with_45usU0AMb5eOpbMeta || {},
    alias: how_45to_45build_45with_45usU0AMb5eOpbMeta?.alias || [],
    redirect: how_45to_45build_45with_45usU0AMb5eOpbMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/how-to-build-with-us.vue").then(m => m.default || m)
  },
  {
    name: indexBleDxhtVBSMeta?.name ?? "about-us",
    path: indexBleDxhtVBSMeta?.path ?? "/about-us",
    meta: indexBleDxhtVBSMeta || {},
    alias: indexBleDxhtVBSMeta?.alias || [],
    redirect: indexBleDxhtVBSMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45team9NeELQURFTMeta?.name ?? "about-us-our-team",
    path: our_45team9NeELQURFTMeta?.path ?? "/about-us/our-team",
    meta: our_45team9NeELQURFTMeta || {},
    alias: our_45team9NeELQURFTMeta?.alias || [],
    redirect: our_45team9NeELQURFTMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/our-team.vue").then(m => m.default || m)
  },
  {
    name: preferred_45lender8Xif8u2qUUMeta?.name ?? "about-us-preferred-lender",
    path: preferred_45lender8Xif8u2qUUMeta?.path ?? "/about-us/preferred-lender",
    meta: preferred_45lender8Xif8u2qUUMeta || {},
    alias: preferred_45lender8Xif8u2qUUMeta?.alias || [],
    redirect: preferred_45lender8Xif8u2qUUMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/preferred-lender.vue").then(m => m.default || m)
  },
  {
    name: realtor_45resourcesysr2Ntet62Meta?.name ?? "about-us-realtor-resources",
    path: realtor_45resourcesysr2Ntet62Meta?.path ?? "/about-us/realtor-resources",
    meta: realtor_45resourcesysr2Ntet62Meta || {},
    alias: realtor_45resourcesysr2Ntet62Meta?.alias || [],
    redirect: realtor_45resourcesysr2Ntet62Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/about-us/realtor-resources.vue").then(m => m.default || m)
  },
  {
    name: _91post_93lBoVDjBplaMeta?.name ?? "blog-post",
    path: _91post_93lBoVDjBplaMeta?.path ?? "/blog/:post()",
    meta: _91post_93lBoVDjBplaMeta || {},
    alias: _91post_93lBoVDjBplaMeta?.alias || [],
    redirect: _91post_93lBoVDjBplaMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/blog/[post].vue").then(m => m.default || m)
  },
  {
    name: indexrPrcp8A4vWMeta?.name ?? "blog-category-category",
    path: indexrPrcp8A4vWMeta?.path ?? "/blog/category/:category()",
    meta: indexrPrcp8A4vWMeta || {},
    alias: indexrPrcp8A4vWMeta?.alias || [],
    redirect: indexrPrcp8A4vWMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/blog/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indexP25F3Fe0r3Meta?.name ?? "blog",
    path: indexP25F3Fe0r3Meta?.path ?? "/blog",
    meta: indexP25F3Fe0r3Meta || {},
    alias: indexP25F3Fe0r3Meta?.alias || [],
    redirect: indexP25F3Fe0r3Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93ddwMqJmEPpMeta?.name ?? "campaigns-slug",
    path: _91_46_46_46slug_93ddwMqJmEPpMeta?.path ?? "/campaigns/:slug(.*)*",
    meta: _91_46_46_46slug_93ddwMqJmEPpMeta || {},
    alias: _91_46_46_46slug_93ddwMqJmEPpMeta?.alias || [],
    redirect: _91_46_46_46slug_93ddwMqJmEPpMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/campaigns/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexHt7RZpWnYZMeta?.name ?? "campaigns",
    path: indexHt7RZpWnYZMeta?.path ?? "/campaigns",
    meta: indexHt7RZpWnYZMeta || {},
    alias: indexHt7RZpWnYZMeta?.alias || [],
    redirect: indexHt7RZpWnYZMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/campaigns/index.vue").then(m => m.default || m)
  },
  {
    name: central_45park_45special_45offer28wB4AiENWMeta?.name ?? "central-park-special-offer",
    path: central_45park_45special_45offer28wB4AiENWMeta?.path ?? "/central-park-special-offer",
    meta: central_45park_45special_45offer28wB4AiENWMeta || {},
    alias: central_45park_45special_45offer28wB4AiENWMeta?.alias || [],
    redirect: central_45park_45special_45offer28wB4AiENWMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/central-park-special-offer.vue").then(m => m.default || m)
  },
  {
    name: ask_45a_45question7Xn4FiGFYuMeta?.name ?? "contact-us-ask-a-question",
    path: ask_45a_45question7Xn4FiGFYuMeta?.path ?? "/contact-us/ask-a-question",
    meta: ask_45a_45question7Xn4FiGFYuMeta || {},
    alias: ask_45a_45question7Xn4FiGFYuMeta?.alias || [],
    redirect: ask_45a_45question7Xn4FiGFYuMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/ask-a-question.vue").then(m => m.default || m)
  },
  {
    name: career_45opportunitiesEkK5P5SRYgMeta?.name ?? "contact-us-career-opportunities",
    path: career_45opportunitiesEkK5P5SRYgMeta?.path ?? "/contact-us/career-opportunities",
    meta: career_45opportunitiesEkK5P5SRYgMeta || {},
    alias: career_45opportunitiesEkK5P5SRYgMeta?.alias || [],
    redirect: career_45opportunitiesEkK5P5SRYgMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/career-opportunities.vue").then(m => m.default || m)
  },
  {
    name: faqGpfUPhBydPMeta?.name ?? "contact-us-faq",
    path: faqGpfUPhBydPMeta?.path ?? "/contact-us/faq",
    meta: faqGpfUPhBydPMeta || {},
    alias: faqGpfUPhBydPMeta?.alias || [],
    redirect: faqGpfUPhBydPMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/faq.vue").then(m => m.default || m)
  },
  {
    name: homeowner_45resourcesUEY7bB1HXnMeta?.name ?? "contact-us-homeowner-resources",
    path: homeowner_45resourcesUEY7bB1HXnMeta?.path ?? "/contact-us/homeowner-resources",
    meta: homeowner_45resourcesUEY7bB1HXnMeta || {},
    alias: homeowner_45resourcesUEY7bB1HXnMeta?.alias || [],
    redirect: homeowner_45resourcesUEY7bB1HXnMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/homeowner-resources.vue").then(m => m.default || m)
  },
  {
    name: indexeIDe1a4SPQMeta?.name ?? "contact-us",
    path: indexeIDe1a4SPQMeta?.path ?? "/contact-us",
    meta: indexeIDe1a4SPQMeta || {},
    alias: indexeIDe1a4SPQMeta?.alias || [],
    redirect: indexeIDe1a4SPQMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/index.vue").then(m => m.default || m)
  },
  {
    name: our_45locationsiUMWDW55u3Meta?.name ?? "contact-us-our-locations",
    path: our_45locationsiUMWDW55u3Meta?.path ?? "/contact-us/our-locations",
    meta: our_45locationsiUMWDW55u3Meta || {},
    alias: our_45locationsiUMWDW55u3Meta?.alias || [],
    redirect: our_45locationsiUMWDW55u3Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/contact-us/our-locations.vue").then(m => m.default || m)
  },
  {
    name: current_45offersxy1mGaWzwGMeta?.name ?? "current-offers",
    path: current_45offersxy1mGaWzwGMeta?.path ?? "/current-offers",
    meta: current_45offersxy1mGaWzwGMeta || {},
    alias: current_45offersxy1mGaWzwGMeta?.alias || [],
    redirect: current_45offersxy1mGaWzwGMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/current-offers.vue").then(m => m.default || m)
  },
  {
    name: indexHRy12ngdA1Meta?.name ?? "events-event",
    path: indexHRy12ngdA1Meta?.path ?? "/events/:event()",
    meta: indexHRy12ngdA1Meta || {},
    alias: indexHRy12ngdA1Meta?.alias || [],
    redirect: indexHRy12ngdA1Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/events/[event]/index.vue").then(m => m.default || m)
  },
  {
    name: indexD2PJucc5zgMeta?.name ?? "events",
    path: indexD2PJucc5zgMeta?.path ?? "/events",
    meta: indexD2PJucc5zgMeta || {},
    alias: indexD2PJucc5zgMeta?.alias || [],
    redirect: indexD2PJucc5zgMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/events/index.vue").then(m => m.default || m)
  },
  {
    name: index0V08VrZyl7Meta?.name ?? "homes-location-community",
    path: index0V08VrZyl7Meta?.path ?? "/homes/:location()/:community()",
    meta: index0V08VrZyl7Meta || {},
    alias: index0V08VrZyl7Meta?.alias || [],
    redirect: index0V08VrZyl7Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/index.vue").then(m => m.default || m)
  },
  {
    name: indexMmvppV54c5Meta?.name ?? "homes-location-community-models-model",
    path: indexMmvppV54c5Meta?.path ?? "/homes/:location()/:community()/models/:model()",
    meta: indexMmvppV54c5Meta || {},
    alias: indexMmvppV54c5Meta?.alias || [],
    redirect: indexMmvppV54c5Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/models/[model]/index.vue").then(m => m.default || m)
  },
  {
    name: index7cEVnkZD7RMeta?.name ?? "homes-location-community-plans-plan",
    path: index7cEVnkZD7RMeta?.path ?? "/homes/:location()/:community()/plans/:plan()",
    meta: index7cEVnkZD7RMeta || {},
    alias: index7cEVnkZD7RMeta?.alias || [],
    redirect: index7cEVnkZD7RMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/plans/[plan]/index.vue").then(m => m.default || m)
  },
  {
    name: indexfU9n3gZe3dMeta?.name ?? "homes-location-community-qmi-home",
    path: indexfU9n3gZe3dMeta?.path ?? "/homes/:location()/:community()/qmi/:home()",
    meta: indexfU9n3gZe3dMeta || {},
    alias: indexfU9n3gZe3dMeta?.alias || [],
    redirect: indexfU9n3gZe3dMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/homes/[location]/[community]/qmi/[home]/index.vue").then(m => m.default || m)
  },
  {
    name: index1Eborj6IasMeta?.name ?? "index",
    path: index1Eborj6IasMeta?.path ?? "/",
    meta: index1Eborj6IasMeta || {},
    alias: index1Eborj6IasMeta?.alias || [],
    redirect: index1Eborj6IasMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/index.vue").then(m => m.default || m)
  },
  {
    name: knolls_45hoa_45informationgXnrT0qNOXMeta?.name ?? "knolls-hoa-information",
    path: knolls_45hoa_45informationgXnrT0qNOXMeta?.path ?? "/knolls-hoa-information",
    meta: knolls_45hoa_45informationgXnrT0qNOXMeta || {},
    alias: knolls_45hoa_45informationgXnrT0qNOXMeta?.alias || [],
    redirect: knolls_45hoa_45informationgXnrT0qNOXMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/knolls-hoa-information.vue").then(m => m.default || m)
  },
  {
    name: land_45acquisitionDaIGod2u5xMeta?.name ?? "land-acquisition",
    path: land_45acquisitionDaIGod2u5xMeta?.path ?? "/land-acquisition",
    meta: land_45acquisitionDaIGod2u5xMeta || {},
    alias: land_45acquisitionDaIGod2u5xMeta?.alias || [],
    redirect: land_45acquisitionDaIGod2u5xMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/land-acquisition.vue").then(m => m.default || m)
  },
  {
    name: brents_45place5SxJlqPSN4Meta?.name ?? "lifestyle-brents-place",
    path: brents_45place5SxJlqPSN4Meta?.path ?? "/lifestyle/brents-place",
    meta: brents_45place5SxJlqPSN4Meta || {},
    alias: brents_45place5SxJlqPSN4Meta?.alias || [],
    redirect: brents_45place5SxJlqPSN4Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/brents-place.vue").then(m => m.default || m)
  },
  {
    name: experience_45lower_45maintenance5RB1H5rIC2Meta?.name ?? "lifestyle-experience-lower-maintenance",
    path: experience_45lower_45maintenance5RB1H5rIC2Meta?.path ?? "/lifestyle/experience-lower-maintenance",
    meta: experience_45lower_45maintenance5RB1H5rIC2Meta || {},
    alias: experience_45lower_45maintenance5RB1H5rIC2Meta?.alias || [],
    redirect: experience_45lower_45maintenance5RB1H5rIC2Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/experience-lower-maintenance.vue").then(m => m.default || m)
  },
  {
    name: _91testimonial_93WB7FoknLD1Meta?.name ?? "lifestyle-reviews-testimonial",
    path: _91testimonial_93WB7FoknLD1Meta?.path ?? "/lifestyle/reviews/:testimonial()",
    meta: _91testimonial_93WB7FoknLD1Meta || {},
    alias: _91testimonial_93WB7FoknLD1Meta?.alias || [],
    redirect: _91testimonial_93WB7FoknLD1Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/[testimonial].vue").then(m => m.default || m)
  },
  {
    name: index0DBcSS2QWDMeta?.name ?? "lifestyle-reviews-category-category",
    path: index0DBcSS2QWDMeta?.path ?? "/lifestyle/reviews/category/:category()",
    meta: index0DBcSS2QWDMeta || {},
    alias: index0DBcSS2QWDMeta?.alias || [],
    redirect: index0DBcSS2QWDMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/category/[category]/index.vue").then(m => m.default || m)
  },
  {
    name: indextSUPFlsqFaMeta?.name ?? "lifestyle-reviews",
    path: indextSUPFlsqFaMeta?.path ?? "/lifestyle/reviews",
    meta: indextSUPFlsqFaMeta || {},
    alias: indextSUPFlsqFaMeta?.alias || [],
    redirect: indextSUPFlsqFaMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/reviews/index.vue").then(m => m.default || m)
  },
  {
    name: whats_45lifefullness9QWQdrLpSUMeta?.name ?? "lifestyle-whats-lifefullness",
    path: whats_45lifefullness9QWQdrLpSUMeta?.path ?? "/lifestyle/whats-lifefullness",
    meta: whats_45lifefullness9QWQdrLpSUMeta || {},
    alias: whats_45lifefullness9QWQdrLpSUMeta?.alias || [],
    redirect: whats_45lifefullness9QWQdrLpSUMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/lifestyle/whats-lifefullness.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93aM6p4LBRFXMeta?.name ?? "marshallfire-slug",
    path: _91_46_46_46slug_93aM6p4LBRFXMeta?.path ?? "/marshallfire/:slug(.*)*",
    meta: _91_46_46_46slug_93aM6p4LBRFXMeta || {},
    alias: _91_46_46_46slug_93aM6p4LBRFXMeta?.alias || [],
    redirect: _91_46_46_46slug_93aM6p4LBRFXMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/marshallfire/[...slug].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritessJ0pxTkF0hMeta?.name ?? "my-favorites",
    path: my_45favoritessJ0pxTkF0hMeta?.path ?? "/my-favorites",
    meta: my_45favoritessJ0pxTkF0hMeta || {},
    alias: my_45favoritessJ0pxTkF0hMeta?.alias || [],
    redirect: my_45favoritessJ0pxTkF0hMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: new_45home_45search6Et2b7W5l0Meta?.name ?? "new-home-search",
    path: new_45home_45search6Et2b7W5l0Meta?.path ?? "/new-home-search",
    meta: new_45home_45search6Et2b7W5l0Meta || {},
    alias: new_45home_45search6Et2b7W5l0Meta?.alias || [],
    redirect: new_45home_45search6Et2b7W5l0Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/new-home-search.vue").then(m => m.default || m)
  },
  {
    name: easyhouseI3M84Vp3ujMeta?.name ?? "our-homes-home-collections-easyhouse",
    path: easyhouseI3M84Vp3ujMeta?.path ?? "/our-homes/home-collections/easyhouse",
    meta: easyhouseI3M84Vp3ujMeta || {},
    alias: easyhouseI3M84Vp3ujMeta?.alias || [],
    redirect: easyhouseI3M84Vp3ujMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/easyhouse.vue").then(m => m.default || m)
  },
  {
    name: limitededitionUnYayO26Z7Meta?.name ?? "our-homes-home-collections-limitededition",
    path: limitededitionUnYayO26Z7Meta?.path ?? "/our-homes/home-collections/limitededition",
    meta: limitededitionUnYayO26Z7Meta || {},
    alias: limitededitionUnYayO26Z7Meta?.alias || [],
    redirect: limitededitionUnYayO26Z7Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/limitededition.vue").then(m => m.default || m)
  },
  {
    name: wee_45cottagexmnncYuK6OMeta?.name ?? "our-homes-home-collections-wee-cottage",
    path: wee_45cottagexmnncYuK6OMeta?.path ?? "/our-homes/home-collections/wee-cottage",
    meta: wee_45cottagexmnncYuK6OMeta || {},
    alias: wee_45cottagexmnncYuK6OMeta?.alias || [],
    redirect: wee_45cottagexmnncYuK6OMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/home-collections/wee-cottage.vue").then(m => m.default || m)
  },
  {
    name: indexc7XJjNFFRKMeta?.name ?? "our-homes",
    path: indexc7XJjNFFRKMeta?.path ?? "/our-homes",
    meta: indexc7XJjNFFRKMeta || {},
    alias: indexc7XJjNFFRKMeta?.alias || [],
    redirect: indexc7XJjNFFRKMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-homes/index.vue").then(m => m.default || m)
  },
  {
    name: our_45neighborhoodsW3ixkecGjGMeta?.name ?? "our-neighborhoods",
    path: our_45neighborhoodsW3ixkecGjGMeta?.path ?? "/our-neighborhoods",
    meta: our_45neighborhoodsW3ixkecGjGMeta || {},
    alias: our_45neighborhoodsW3ixkecGjGMeta?.alias || [],
    redirect: our_45neighborhoodsW3ixkecGjGMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/our-neighborhoods.vue").then(m => m.default || m)
  },
  {
    name: partner_45with_45usNBxHTIxAfpMeta?.name ?? "partner-with-us",
    path: partner_45with_45usNBxHTIxAfpMeta?.path ?? "/partner-with-us",
    meta: partner_45with_45usNBxHTIxAfpMeta || {},
    alias: partner_45with_45usNBxHTIxAfpMeta?.alias || [],
    redirect: partner_45with_45usNBxHTIxAfpMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/partner-with-us.vue").then(m => m.default || m)
  },
  {
    name: peacockK6Ffff2U7WMeta?.name ?? "peacock",
    path: peacockK6Ffff2U7WMeta?.path ?? "/peacock",
    meta: peacockK6Ffff2U7WMeta || {},
    alias: peacockK6Ffff2U7WMeta?.alias || [],
    redirect: peacockK6Ffff2U7WMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/peacock.vue").then(m => m.default || m)
  },
  {
    name: privacytermsBHlYfLgB1HMeta?.name ?? "privacyterms",
    path: privacytermsBHlYfLgB1HMeta?.path ?? "/privacyterms",
    meta: privacytermsBHlYfLgB1HMeta || {},
    alias: privacytermsBHlYfLgB1HMeta?.alias || [],
    redirect: privacytermsBHlYfLgB1HMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/privacyterms.vue").then(m => m.default || m)
  },
  {
    name: sandboxBtaV080HPWMeta?.name ?? "sandbox",
    path: sandboxBtaV080HPWMeta?.path ?? "/sandbox",
    meta: sandboxBtaV080HPWMeta || {},
    alias: sandboxBtaV080HPWMeta?.alias || [],
    redirect: sandboxBtaV080HPWMeta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/sandbox.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93yVJLj5lxG2Meta?.name ?? "videos-slug",
    path: _91_46_46_46slug_93yVJLj5lxG2Meta?.path ?? "/videos/:slug(.*)*",
    meta: _91_46_46_46slug_93yVJLj5lxG2Meta || {},
    alias: _91_46_46_46slug_93yVJLj5lxG2Meta?.alias || [],
    redirect: _91_46_46_46slug_93yVJLj5lxG2Meta?.redirect,
    component: () => import("/codebuild/output/src163514044/src/livebcn-headless/nuxtapp/pages/videos/[...slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/about-us/get-our-brochure/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/about-us/in-the-news/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/about-us/realtor-program/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/about-us/what-we-do/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/about-us/who-we-are/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/build-with-us/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/career-opportunities/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/career-opportunities/administrative-assistant-2/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/career-opportunities/director-of-warranty-services/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/career-opportunities/land-development-entitlements-coordinator/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/contact-us/ask-a-question/thank-you/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/contact-us/warranty-services/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/email-signup/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/get-updates/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/get-updates/thank-you/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/how-to-video-library/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/lifestyle/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/locations/lanterns-at-rock-creek/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/locations/silver-leaf/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/locations/wee-cottage-at-north-end-80238/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/locations/wee-cottage-at-rogers-farm/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/locations/west-edge-at-colliers-hill/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/login/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/lost-password/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/maintenance-items/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/marshall-fire-response/thank-you-loi/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/neighborhoods-map-test/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/organism-page/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/home-collections/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/home-collections/lanterns-series/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/home-collections/opportunities-series/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/photo-gallery/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/photo-gallery/gourmet-kitchens/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/photo-gallery/home-offices/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/photo-gallery/living-rooms/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/photo-gallery/outdoor-living-spaces/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/our-homes/photo-gallery/relaxing-master-suites/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/register/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/reset-password/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/resources-lower-maintenance/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/style-guide/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  },
  {
    name: component_45stubekCUiKQWjcMeta?.name ?? undefined,
    path: component_45stubekCUiKQWjcMeta?.path ?? "/warranty-service-request/",
    meta: component_45stubekCUiKQWjcMeta || {},
    alias: component_45stubekCUiKQWjcMeta?.alias || [],
    redirect: component_45stubekCUiKQWjcMeta?.redirect,
    component: component_45stubekCUiKQWjc
  }
]